import { api } from "./client";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const createSalesOrder = async (formData) => {
  try {
    const token = localStorage.getItem("token");
    const lang = localStorage.getItem("lang") || "en";

    const response = await api.post(
      `${API_BASE_URL}api/sales-orders/add`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "Accept-Language": lang,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Create Sales Order API Error:", error);
    throw error.response?.data || { message: "Failed to create sales order" };
  }
};

export const fetchSalesOrders = async () => {
  try {
    const token = localStorage.getItem("token");
    const lang = localStorage.getItem("lang") || "en";

    const response = await api.get(`${API_BASE_URL}api/sales-orders/online-list`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Accept-Language": lang,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Fetch Sales Orders API Error:", error);
    throw error.response?.data || { message: "Failed to fetch sales orders" };
  }
};


export const getSalesOrderById = async (id) => {
  try {
    const token = localStorage.getItem("token");
    const lang = localStorage.getItem("lang") || "en";

    const res = await fetch(`${API_BASE_URL}api/sales-orders/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Accept-Language": lang,
      },
    });

    if (!res.ok) throw await res.json();
    return await res.json();
  } catch (err) {
    console.error("Fetch sales order by ID failed", err);
    throw err;
  }
};